// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCNyDhTfddeer2g37EwVW2SK1baEgFGlEI",
  authDomain: "hello-kayii.firebaseapp.com",
  projectId: "hello-kayii",
  storageBucket: "hello-kayii.appspot.com",
  messagingSenderId: "982367145449",
  appId: "1:982367145449:web:9284b56432af33c35acf78",
  measurementId: "G-7KKMPR9Y1H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);